const initialState = {
  email: '',
  name: '',
  phone: '',
  state: '',
  public_id: '',
  is_admin: false,
  isLogged: false
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_EMAIL':
      return {...state, email: action.payload.email};
    case 'SET_USER':
      return {
        ...state,
        email: action.payload.email || '',
        name: action.payload.name || '',
        phone: action.payload.phone || '',
        state: action.payload.state || '',
        public_id: action.payload.public_id || '',
        is_admin: action.payload.is_admin || false,
        isLogged: true
      };
    case 'CLEAR_USER':
      return initialState;
    default:
      return state;
  }
};

export default userReducer;